export const integrationDocumentationUrls = {
    xero: 'https://support.approvalmax.com/portal/kb/approvalmax-1/approvalmax-for-xero',
    quickbooks: 'https://support.approvalmax.com/portal/kb/approvalmax-1/approvalmax-for-quickbooks-online',
    netsuite: 'https://support.approvalmax.com/portal/en/kb/approvalmax-1/approvalmax-for-netsuite',
    cin7: 'https://support.approvalmax.com/portal/en/kb/approvalmax-1/approvalmax-for-dear',
};
